import { Select as MuiSelect, MenuItem as MuiMenuItem } from '@mui/material';
import { FieldProps, SelectFieldSchema } from '../types/Form';
import { FieldWrapper } from './FieldWrapper';

export const Select: React.FC<FieldProps<SelectFieldSchema>> = ({
  name,
  value,
  field,
  errorMessage,
  onChange
}) => {
  const { label, subLabel, containerSx, ...restField } = field;

  return (
    <FieldWrapper
      label={label}
      subLabel={subLabel}
      errorMessage={errorMessage}
      sx={containerSx}
    >
      <MuiSelect
        data-testid={`select-${name}`}
        fullWidth
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        {...restField}
        label={undefined}
        error={!!errorMessage}
      >
        {field.options.map((option) => (
          <MuiMenuItem
            data-testid={`select-option-${option.value}`}
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </MuiMenuItem>
        ))}
      </MuiSelect>
    </FieldWrapper>
  );
};
